var cabDetails = (function () {
    'use strict';

    var conformityProcedure = document.getElementById('ConformityProcedure');
    var additionalConformityProcedure = document.getElementById('AdditionalConformityProcedure');
    var additionalProcedureWrapper = document.getElementById('additional-conformity-procedure-wrapper');
    var cabDetailsWrapper = document.getElementById('cab-details-wrapper');
    var additionalCabDetailsWrapper = document.getElementById('additional-cab-details-wrapper');
    var internalProcedureWrapper = document.getElementById('internal-procedure-wrapper');
    var internalAdditionalProcedureWrapper = document.getElementById('internal-additional-procedure-wrapper');
    var internalProcedureCheckbox = document.querySelector('[name="IsConformityProcedureCarriedOutInternally"]');
    var internalAdditionalProcedureCheckbox = document.querySelector('[name="IsAdditionalConformityProcedureCarriedOutInternally"]');
    var reuseExistingCabDetailsCheckbox = document.getElementById("CopyExistingCabDetails");
    var reuseExistingCabDetailsCheckboxWrapper = document.getElementById("reuse-cab-name-number");
    var cabNameInputBox = document.getElementById('CabName');
    var bodyNumberInputBox = document.getElementById('BodyNumber');
    var additionalCabName = document.getElementById('AdditionalCabName');
    var additionalBodyNumber = document.getElementById('AdditionalBodyNumber');
    var designExamCertNumberWrapper = document.getElementById('design-exam-certificate-number-wrapper');
    const modelH1 = "Module H1: Conformity based on full quality assurance plus design examination";

    // Todo - When reuse is checked, copy value of cab name and number into additional cab fields
    function copyExistingCabNameAndNumber()
    {
        if (reuseExistingCabDetailsCheckbox.checked) {
            additionalCabName.value = cabNameInputBox.value;
            additionalBodyNumber.value = bodyNumberInputBox.value;
        } else {
            additionalCabName.value = "";
            additionalBodyNumber.value = "";
        }
    }

    function isInternalProcedure()
    {
        var main = conformityProcedure ? conformityProcedure.value : '';
        var checkboxChecked = internalProcedureCheckbox ? internalProcedureCheckbox.checked : false;

        return main === 'Module A: Internal Production Control' || checkboxChecked;
    }

    function isInternalAddtionalProcedure() {
        var additional = additionalConformityProcedure ? additionalConformityProcedure.value : '';
        var checkboxChecked = internalAdditionalProcedureCheckbox ? internalAdditionalProcedureCheckbox.checked : false;

        return additional === 'Module C: Conformity to type based on internal production control' || checkboxChecked;
    }

    function canChooseInternalAdditionalProcedure() {
        var additional = additionalConformityProcedure ? additionalConformityProcedure.value : '';

        return additional === 'Module C1: Conformity to type based on internal production control plus supervised product testing' ||
            additional === 'Module C2: Conformity to type based on internal production control plus supervised product checks at random intervals';
    }

    function canChooseInternalProcedure() {
        var main = conformityProcedure ? conformityProcedure.value : '';

        return main === 'Module A1: Internal production control plus supervised product testing' ||
            main === 'Module A2: Internal production control plus supervised product checks at random intervals';
    }

    function showDesignExamCertNum() {
        if (!designExamCertNumberWrapper) return;
        designExamCertNumberWrapper.style.display = conformityProcedure.value === modelH1 ? 'block' : 'none';
        return true;
    }

    function updateVisibility()
    {
        if (!conformityProcedure || !additionalProcedureWrapper) return;

        additionalProcedureWrapper.style.display = conformityProcedure.value.startsWith('Module B') ? 'block' : 'none';

        showDesignExamCertNum();

        if (internalProcedureWrapper)
        {
            internalProcedureWrapper.style.display = canChooseInternalProcedure() ? 'block' : 'none';
        }

        if (internalAdditionalProcedureWrapper)
        {
            internalAdditionalProcedureWrapper.style.display = canChooseInternalAdditionalProcedure() ? 'block' : 'none';
        }

        if (!canChooseInternalProcedure() && internalProcedureCheckbox)
        {
            internalProcedureCheckbox.checked = false;
        }

        if (!canChooseInternalAdditionalProcedure() && internalAdditionalProcedureCheckbox)
        {
            internalAdditionalProcedureCheckbox.checked = false;
        }

        if (cabDetailsWrapper)
        {
            cabDetailsWrapper.style.display = isInternalProcedure() ? 'none' : 'block';
        }

        if (additionalCabDetailsWrapper)
        {
            additionalCabDetailsWrapper.style.display = isInternalAddtionalProcedure() ? 'none' : 'block';
        }

        if (cabNameInputBox.value != "" && bodyNumberInputBox.value != "" && additionalConformityProcedure.value != "" && !isInternalAddtionalProcedure()) {
            reuseExistingCabDetailsCheckboxWrapper.style.display = 'block';
        } else {
            reuseExistingCabDetailsCheckbox.checked = false;
            additionalCabName.value = "";
            additionalBodyNumber.value = "";
            reuseExistingCabDetailsCheckboxWrapper.style.display = 'none';
        }
    }

    function init()
    {
        if (!conformityProcedure || !additionalProcedureWrapper) return;

        conformityProcedure.addEventListener('change', updateVisibility);

        if (additionalConformityProcedure)
        {
            additionalConformityProcedure.addEventListener('change', updateVisibility);
        }

        if (internalProcedureCheckbox)
        {
            internalProcedureCheckbox.addEventListener('change', updateVisibility);
        }

        if (internalAdditionalProcedureCheckbox)
        {
            internalAdditionalProcedureCheckbox.addEventListener('change', updateVisibility);
        }

        if (reuseExistingCabDetailsCheckbox)
        {
            reuseExistingCabDetailsCheckbox.addEventListener('change', copyExistingCabNameAndNumber)
        }

        if (cabNameInputBox) {
            cabNameInputBox.addEventListener('change', updateVisibility)
        }

        if (bodyNumberInputBox) {
            bodyNumberInputBox.addEventListener('change', updateVisibility)
        }

        updateVisibility();
    }

    return { init };
})();

cabDetails.init();